/*    
<summary>
   This file is used to provide initial values or state to the release Data observables.
   Developer:Ashish Singh, Created Date: 04-July-2025
</summary>
*/
import { getEffectiveDateForSchedule } from "../../constants/common-constants";
import { IAddReleaseScheduler } from "../../models/response/IFotaNewResponse";

export const initialValues: IAddReleaseScheduler = {
  IsUpdateNow: "0",
  ScheduleDate:getEffectiveDateForSchedule(),
  Description: "",
  WantToUpdateDevices: "false",
  IsAppliedOnGroup: "true",
  GroupIds: [],
  ICCIDs: [],
  ICCIDsFile:"",
  ICCIDsFileContent:"",
  ConfigId: -1,        
  ScheduleDurationDay: 1,
};